import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiButton: Components<CssVarsTheme>['MuiButton'] = {
  defaultProps: {
    variant: 'contained',
    color: 'inherit'
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
      whiteSpace: 'nowrap'
    }
  },
  variants: [
    {
      props: { variant: 'contained', color: 'inherit' },
      style: ({ theme }) => {
        return {
          backgroundColor: theme.vars?.palette.grey['800'],
          color: '#ffffff',
          '&:hover': {
            backgroundColor: theme.vars?.palette.grey['700']
          }
        };
      }
    }
  ]
};

export const MuiLoadingButton: Components<CssVarsTheme>['MuiLoadingButton'] = {
  defaultProps: {
    variant: 'contained'
  }
};

export const MuiIconButton: Components<CssVarsTheme>['MuiIconButton'] = {
  defaultProps: {
    size: 'small',
    color: 'inherit'
  },
  variants: [
    {
      props: { color: 'inherit' },
      style: ({ theme }) => {
        return {
          color: theme.vars.palette.text.secondary
        };
      }
    }
  ]
};
